<template>
    <router-link class="big-nav-btn flex flex-column justify-center p3 mb2 mx2" :to="link">
        <img class="mx-auto mb3" style="width: 120px;" :src="require(`../assets/${img}`)">
        <h2 class="h3 bold caps center">{{linktext}}</h2>
    </router-link>
</template>
<script>
export default {
    name: "BigNavBtn",
        data() {
        return {
        };
    },
    props: {
        'linktext': String, 
        'link': String,
        'img': String
    }

}
</script>
<style>

</style>